await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/commerce-frontend-js/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export function debouncePromise(f, interval) {
	let timer = null;

	return (...args) => {
		clearTimeout(timer);

		return new Promise((resolve) => {
			timer = setTimeout(() => resolve(f(...args)), interval);
		});
	};
}
